<template>
  <div class="main-div">
    <v-container fluid grid-list-md :style="{ maxWidth: '1271px' }">
      <v-layout row wrap>
        <v-flex xs12 md12 lg12>
          <h2 class="head mb-32 pt-40">
            Whitelabel GSMG
          </h2>
          <v-tabs
            v-model="active"
            class="my-0 fill-height"
            slider-color="transparent fill-height"
            height="40"
            color="transparent"
          >
            <v-tab
              v-for="item in items"
              :key="item.id"
              ripple
              class="exchange-tab"
            >
              {{ item.title }}
            </v-tab>
            <v-tab-item :key="0">
              <General @changeTab="onChangeTab"></General>
            </v-tab-item>
            <v-tab-item :key="1">
              <Apikeys></Apikeys>
            </v-tab-item>
            <v-tab-item :key="2">
              <Accounts></Accounts>
            </v-tab-item>
            <v-tab-item :key="3">
              <Payouts></Payouts>
            </v-tab-item>
            <v-tab-item :key="4">
              <Documentation></Documentation>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<style scoped>
.theme--light.application .main-div {
  background-color: #f2f7ff !important;
}

>>> .v-window {
  display: flex;
  flex-direction: column;
  height: 100%;
}
>>> .v-window__container {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.fill-height {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.theme--light h2.head {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: left;
  letter-spacing: 0.02em;
  color: #103a84;
}
.theme--light.v-toolbar {
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}
.theme--light .v-toolbar__title {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: center;
  letter-spacing: 0.02em;
  color: #103a84;
}
>>> .theme--light .v-tabs__item {
  color: #468aff;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .v-tabs__item img {
  margin-right: 8px;
}
>>> .theme--light .exchange-tab {
  background: rgba(255, 255, 255, 0.3);
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
>>> .theme--light .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #0051dd;
  background: #ffffff;
  box-shadow: 4px 6px 20px rgba(57, 95, 169, 0.18);
  border-radius: 10px 10px 0px 0px;
}
/**************************************/
.theme--dark h2.head {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: bold;
  font-size: 22px;
  line-height: 26px;
  text-align: left;
  letter-spacing: 0.02em;
  color: #ffffff;
}
>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}

>>> .theme--dark .exchange-tab a.v-tabs__item--active {
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
  color: #ffffff;
  background: #212121;
  border-radius: 10px 10px 0px 0px;
}
>>> .theme--dark .v-tabs__item {
  color: #e9e9e9;
  font-family: "Lato", serif !important;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-transform: uppercase;
}
>>> .theme--dark.v-tabs__bar {
  background-color: #303030 !important;
}
>>> .theme--dark .exchange-tab {
  background: #454547;
  box-shadow: 6px 4px 10px rgba(0, 0, 0, 0.25);
  margin-right: 2px;
  border-radius: 10px 10px 0px 0px;
  min-width: 144px;
}
</style>
<script>
import { mapGetters } from "vuex";
import General from "../components/whitelabel/General";
import Apikeys from "../components/whitelabel/Apikeys";
import Accounts from "../components/whitelabel/Accounts";
import Payouts from "../components/whitelabel/Payouts";
import Documentation from "../components/whitelabel/Documentation";

export default {
  components: {
    General,
    Apikeys,
    Accounts,
    Payouts,
    Documentation
  },
  data: () => ({
    items: [
      { id: 1, title: "General" },
      { id: 2, title: "API keys" },
      { id: 3, title: "Accounts" },
      { id: 4, title: "Payouts" },
      { id: 5, title: "API Docs" }
    ],
    active: null
  }),
  computed: {
    ...mapGetters({
      user: "auth/user",
      darkmode: "settings/darkmode"
    }),
    themeMode: function() {
      return this.darkmode ? "dark" : "light";
    },
    isMobile: function() {
      return this.windowWidth < 769;
    }
  },
  mounted: function() {
    window.onresize = () => {
      this.windowWidth = window.innerWidth;
    };
  },
  methods: {
    onChangeTab(data) {
      this.active = data.tab;
    },
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/js/pages/whitelabel.vue